import { Button } from 'components/Button/Button';
import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import { Formik } from 'formik';

import { Stakeholder } from 'services/person/person.types';

import { AddressAutocomplete } from 'components/Address/Address';
import FormErrorMessage from 'components/FormErrorMessage/FormErrorMessage';
import usePersonStakeholderFormVM from './usePersonStakeholderFormVM';
import { addPersonStakeHolderSchema } from './PersonStakeholderFormSchema';
import { Datalist } from 'components/Datalist/Datalist';
import TipTap from 'components/TipTap/TipTap';

export function PersonStakeholderForm() {
    const { stakeholderValues, isEdit, handleAddOrEditStakeholder, isLoading } = usePersonStakeholderFormVM();

    const initialValues = isEdit && stakeholderValues ? stakeholderValues : {
        id: 0,
        fullname: '',
        main_contact: false,
        legal_contact: false,
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        status: '',
        address: {
            address: '',
            address_add: '',
            city: '',
            zipcode: '',
            country: ''
        },
        observation: ''
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={() => addPersonStakeHolderSchema()}
                onSubmit={async (values: Stakeholder, { setSubmitting }) => {
                    handleAddOrEditStakeholder(values);
                    setSubmitting(false);
                }}
            >
                {({ values, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
                    return (
                        <form onSubmit={handleSubmit} className="form">
                            {/* <FormikDebug values={values} /> */}
                            <ContentBlock title={isEdit ? "Informations de la personne à modifier":"Informations de la personne à ajouter"} isLoading={isLoading}>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Nom</label>
                                        <input
                                            type="text"
                                            className="uppercase"
                                            name="lastname"
                                            placeholder="Doe"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.lastname}
                                            required
                                        />
                                        <FormErrorMessage field="lastname" />
                                    </div>
                                    <div className="form-group">
                                        <label>Prénom</label>
                                        <input
                                            type="text"
                                            name="firstname"
                                            placeholder="John"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.firstname}
                                            required
                                        />
                                        <FormErrorMessage field="firstname" />
                                    </div>
                                    <div className="form-group">
                                        <label>Status</label>
                                        <Datalist
                                            list="stakeholder_status"
                                            name="status"
                                            placeholder="Sélectionner un status"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.status}
                                            required
                                        />
                                        <FormErrorMessage field="status" />
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john.doe@gmail.com"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.email}
                                        />
                                        <FormErrorMessage field="email" />
                                    </div>
                                    <div className="form-group">
                                        <label>Téléphone</label>
                                        <input
                                            type="text"
                                            name="phone"
                                            placeholder="0606060606"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.phone}
                                        />
                                        <FormErrorMessage field="phone" />
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Adresse postale</label>
                                        <div className="fields address">
                                            <AddressAutocomplete
                                                baseField="address"
                                                formValue={values.address}
                                                setValue={setFieldValue}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Commentaire</label>
                                        <div className="wysiwyg-container">
                                            <TipTap
                                                name="observation"
                                                value={values.observation}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        <FormErrorMessage field="observation" />
                                    </div>
                                </div>
                                <Button type="submit" label={isEdit ? "Modifer le proche" : "Ajouter un proche"} />
                            </ContentBlock>
                        </form>
                    );
                }}
            </Formik>
        </>
    );
}
